import { render, staticRenderFns } from "./CompraDetalhesLinks.vue?vue&type=template&id=d985723c&"
import script from "./CompraDetalhesLinks.vue?vue&type=script&lang=js&"
export * from "./CompraDetalhesLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports